import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { JobOwnershipRoleEx, JobOwnershipTemplateItem, ListItem, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './job-ownership-template-item.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class JobOwnershipTemplateItemComponent extends RepositoryModal<JobOwnershipTemplateItem> {
    roleOptions: ListItem<number>[] = [new ListItem(null as unknown as number, 'No one (assign manually)'), ...JobOwnershipRoleEx.toListItems()]

    protected onInitialized(): void {
        if (this.target.assignedRole == null) this.target.assignedRole = null
    }

    onBeforeSave() {
        if (this.isAdding) {
            this.target.jobOwnershipTemplateId = this.editOptions.initializeParams.grid.selectedItem.id
            this.target.order = this.editOptions.initializeParams.itemGrid.view.items.length
        }
        return true
    }
}
